import { randWord, randNumber, randParagraph } from '@ngneat/falso';
import { optional } from '@library/common/functions';

import { ReportResponse } from './report-response';

export class MockReportResponse extends ReportResponse {
   constructor( schema?: any[] ) {
      super();

      if ( schema ) {
         schema.map( s => this.headers[s.name] = s?.header ?? s?.name );
      } else {
         // set headers
         Array.from(
            { length: ( randNumber({ max: 10 }) + 1 )},
            _ => this.headers[ randWord().toLowerCase() ] = randWord({ length: 2 }).join( ' ' )
         );
      }

      // create mock data
      this.collection = Array.from({ length: 10 }, _ => {
         const obj = {};
         Object.keys( this.headers ).map( h => {
            Object.assign( obj, {[ h ]: optional() ? randParagraph() : randWord({ length: 2 }).join( ' ' ) });
         });

         return obj;
      });
   }
}
